import { routes, useCurrentRoute } from "config/routes";
import { MUTATION_KEYS } from "hooks/data/queryKeys";
import { useIsMutating } from "react-query";
import { useSelector } from "store/hooks";

function useIsApproveVehiclePendingStatusLoading(vehicleId: string | number) {
  const route = useCurrentRoute();

  const isRequireActionRoute = route === routes.requireActionVehicles.key;

  const selectLocation = isRequireActionRoute
    ? (s) => s.requireActionVehicles.selectedVehicleIds
    : (s) => s.fleetPage.selectedVehicleIds;

  const selectedVehicleIds = useSelector(selectLocation)?.map((item) =>
    Number(item)
  );

  const approveStatusLoadingStatus = !!useIsMutating({
    mutationKey: [MUTATION_KEYS.approveVehiclePendingStatus],
  });

  const isLoading =
    approveStatusLoadingStatus &&
    selectedVehicleIds.includes(Number(vehicleId));

  return isLoading;
}

export default useIsApproveVehiclePendingStatusLoading;
